<template>
  <div>
    <b-alert
        v-model="showCookieNotice"
        variant="info"
        :class="'cookie-notice'"
        dismissible
        @dismissed="handleCookieNoticeDismissed"
    >
      為提供您更好的網站服務，本網站會使用Cookies及其他技術優化用戶體驗，繼續瀏覽本網站，即表示您同意上述聲明及
      <a href="/page/privacy" target="_blank">隱私權政策</a>！
      <button @click="handleAcceptCookies" class="btn btn-primary ml-2">
        同意並關閉視窗
      </button>
    </b-alert>
  </div>
</template>

<script>
export default {
  name: 'CookiePolicy',
  data() {
    return {
      showCookieNotice: true
    };
  },
  mounted() {
    this.hasAcceptedPrivacyPolicy();
  },
  methods: {
    handleCookieNoticeDismissed() {
      //關閉視窗,不同意
      this.showCookieNotice = false;
    },
    // 檢查使用者是否已經同意隱私權政策
    hasAcceptedPrivacyPolicy() {
      this.showCookieNotice = !(this.getCookie('privacyPolicyAccepted') === 'true');
    },
    // 使用者同意隱私權政策，將選擇寫入 cookie
    handleAcceptCookies() {
      this.showCookieNotice = false;
      this.setCookie('privacyPolicyAccepted', 'true', 365); // 有效期 365 天
    },
    // 設置 cookie
    setCookie(name, value, days) {
      const date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      const expires = 'expires=' + date.toUTCString();
      document.cookie = name + '=' + value + ';' + expires + ';path=/';
    },
    getCookie(name) {
      const cookieName = name + '=';
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        let cookie = cookies[i].trim();
        if (cookie.indexOf(cookieName) === 0) {
          return cookie.substring(cookieName.length, cookie.length);
        }
      }
      return '';
    }
  }
};
</script>
